const ProfileSettings = () => {
  return <div>ProfileSettings</div>
}

export default ProfileSettings
